import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

// Get All Meter Readings
export const getMeterReadingsReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_METER_READINGS_API, { params })
}

// Get Meter Reading Details by ID
export const getMeterReadingDetailsReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.GET_METER_READING_DETAILS_API.replace(':id', id);
    return axiosInstance.get(url)
}

// Get Last Reading for a flat/head
export const getLastMeterReadingReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_LAST_METER_READING_API, { params })
}

// Create Meter Reading
export const createMeterReadingReq = (action) => {
    const payload = action?.data || {};
    const body = { ...payload };
    delete body.onSuccess;

    return axiosInstance.post(apiEndpoints.CREATE_METER_READING_API, body)
}

// Bulk Create Meter Readings
export const createBulkMeterReadingsReq = (action) => {
    const payload = action?.data || {};
    const body = { ...payload };
    delete body.onSuccess;

    return axiosInstance.post(apiEndpoints.CREATE_BULK_METER_READINGS_API, body)
}

// Upload Meter Readings via Excel
// Note: head_id, billing_month, billing_year come from Excel columns now
export const uploadMeterReadingsReq = (action) => {
    const { file, society_id } = action?.data || {};

    const formData = new FormData();
    formData.append('file', file);
    formData.append('society_id', society_id);

    return axiosInstance.post(apiEndpoints.UPLOAD_METER_READINGS_API, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// Download Meter Reading Template
export const downloadMeterReadingTemplateReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.DOWNLOAD_METER_READING_TEMPLATE_API, {
        params,
        responseType: 'blob'
    })
}

// Update Meter Reading
export const updateMeterReadingReq = (action) => {
    const payload = action?.data || {};
    const { id } = payload;
    const url = apiEndpoints.UPDATE_METER_READING_API.replace(':id', id);

    const body = { ...payload };
    delete body.id;
    delete body.onSuccess;

    return axiosInstance.put(url, body)
}

// Delete Meter Reading
export const deleteMeterReadingReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.DELETE_METER_READING_API.replace(':id', id);

    return axiosInstance.delete(url)
}
